import { passportInterceptManager, ejectNodeApiInterceptor } from 'library-@/token-base/index.js';

export function ejectCommonInterceptor() {
    passportInterceptManager.eject();
    ejectNodeApiInterceptor();
}
